import { render, staticRenderFns } from "./WalletList.vue?vue&type=template&id=af4f961a&scoped=true"
import script from "./WalletList.vue?vue&type=script&lang=ts"
export * from "./WalletList.vue?vue&type=script&lang=ts"
import style0 from "./WalletList.vue?vue&type=style&index=0&id=af4f961a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4f961a",
  null
  
)

export default component.exports